// extracted by mini-css-extract-plugin
module.exports = {"container":"MyApplications_container__3DlNr","info":"MyApplications_info__MU4jz","empty":"MyApplications_empty__1BGrN","list":"MyApplications_list__F9jt4"};